import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import {
  ACCEPT_BOOKING,
  BOOKING_DETAILS,
  REJECT_BOOKING,
  VIEW_BOOKING,
} from "../../../../services/ApiCalls";
import { toast } from "react-toastify";
import moment from "moment";
import MakeOfferPop from "../../Booking/Modals/MakeOfferPop";
import GetAssignDriver from "../../GetAssignDriver";
import si1 from "../../../../Assets/images/si1.png";
// import ImgPop from "../../../../components/Modals/ImgPop";
import ImagePreview from "../../../../components/Common/ImagePreview";

const GuestBookingDetail = () => {
  // const [imgPreview, setImgPreview] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState();
  const [Offer, setOffer] = useState();
  const [showModalView, setShowModalView] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModalView(true);
  };

  const handleModalClose = () => {
    setShowModalView(false);
    setSelectedImage(null);
  };

  const getData = async () => {
    try {
      const res = await BOOKING_DETAILS(id);

      if (res?.data?.status === "success") {
        setData(res?.data?.data);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };
  const handleOffer = () => setOffer(!Offer);

  const acceptRejectHandler = async (type) => {
    try {
      let res;
      const body = { bookingId: id };
      // if (type === "accept") {
      //   res = await ACCEPT_BOOKING(body);
      // }
      if (type === "reject") {
        res = await REJECT_BOOKING(body);
      }
      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        navigate("/booking/my-bookings");
      } else {
        toast.success(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const [showModal, setShowModal] = useState(false);

  const handleAssignDriver = () => {
    setShowModal(true);
    //   navigate("/assign-driver");
  };

  const handleClose = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (id) getData();
  }, [id]);
  const PICKUP_SIZES = [
    { label: "Small (S): 0 - 10 lbs", value: "S" },
    { label: "Medium (M): 11 - 25 lbs", value: "M" },
    { label: "Large (L): 26 - 50 lbs", value: "L" },
    { label: "Extra Large (XL): 51 - 100 lbs", value: "XL" },
    { label: "2*Extra Large (XXL): > 100 lbs", value: "XXL" },
  ];
  const pickupSize = PICKUP_SIZES.find(
    (size) => size.value === data?.pickUp?.pickUpType.size
  );

  return (
    <>
      {/* <ImgPop imgPreview={imgPreview} setImgPreview={setImgPreview} /> */}
      <MakeOfferPop
        Offer={Offer}
        setOffer={setOffer}
        makeOfferHandler={() => acceptRejectHandler()}
      />

      <section className="bookingDetail py-3 position-relative">
        <Container>
          <Row
          // className="justify-content-center"
          >
            {/* .... PICKUP DETAILS .... */}
            <Col lg="12" className="my-2">
              <div className="py-2">
                <div className="cardCstm p-3 rounded bg-white">
                  <div className="head m-0 mb-2">
                    <h4 className="m-0 fw-bold themeBlue">Pickup Details</h4>
                  </div>
                  <Row className="border-bottom">
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Name:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.pickUpContactName}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Contact Number:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.pickUpContactNumber}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Type:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {/* {data?.pickUp?.pickUpType.size} */}

                          {pickupSize ? pickupSize.label : ""}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Booking ID:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.bookingNumber}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Date
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {moment(data?.pickUp?.pickUpDate).format(
                            "MM/DD/YYYY"
                          )}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Time:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {moment(data?.pickUp?.pickUpTime, "HH:mm:ss").format(
                            "hh:mm A"
                          )}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Pickup Location:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.pickUp?.address}
                        </p>
                      </div>
                    </Col>

                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Booking Type:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.bookingTypeRequest === "normal" ? "Instant" : "Bidding"}
                        </p>
                      </div>
                    </Col>

                  </Row>
                  {/* <Col md="6" sm="6" className="">
                    <div className="inner h-100 border-bottom pb-2">
                      <h6 className="m-0 py-2 fw-bold themeBlue">
                        Document Images:
                      </h6>
                      {data?.driverDetails?.documentsList?.map(
                        (item, index) => (
                          <div key={item._id} className="mb-3">
                            <img
                              // className="img-fluid w-100 rounded"
                              src={item?.image || si1}
                              alt=""
                              width={100}
                              height={100}
                            />
                          </div>
                        )
                      )}
                    </div>
                  </Col> */}
                  <div className="py-2">
                    <h6 className="m-0  fw-bold themeBLue">Additional Notes</h6>
                    <p className="m-0">
                      {data?.pickUp?.additionalNotes}
                    </p>
                  </div>
                </div>
              </div>

              {/*  .... DROPOFF DETAILS .... */}
              <div className="py-2">
                <div className="cardCstm p-3 rounded bg-white">
                  <div className="head m-0 mb-2">
                    <h4 className="m-0 fw-bold themeBlue">Dropoff Details</h4>
                  </div>
                  <Row className="border-bottom">
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Name
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.dropOff?.dropOffContactName}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Contact Number:
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.dropOff?.dropOffContactNumber}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Drop off Location
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.dropOff?.address}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Drop off Date
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {moment(data?.dropOff?.dropOffDate).format(
                            "MM/DD/YYYY"
                          )}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Drop off Time
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {/* {data?.dropOff?.dropOffTime} */}
                          {moment(
                            data?.dropOff?.dropOffTime,
                            "HH:mm:ss"
                          ).format("hh:mm A")}
                        </p>
                      </div>
                    </Col>
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          {id ? "Total Amount" : "Bid Amount"}
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          ${data?.totalOffer}
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
              {/* <div className="cardCstm p-3 rounded bg-white">
                  <div className="head m-0 mb-2">
                    <h4 className="m-0 fw-bold themeBlue">Assigned Driver Details</h4>
                  </div>
                  <Row className="border-bottom">
                    <Col md="4" sm="6" className="">
                      <div className="inner h-100 border-bottom pb-2">
                        <label
                          htmlFor=""
                          className="m-0 form-label themeBlue m-0"
                        >
                          Name
                        </label>
                        <p className="m-0 fw-bold themeClr">
                          {data?.dropOff?.dropOffContactName}
                        </p>
                      </div>
                    </Col>
                  
                  </Row>
                </div> */}
            </Col>
            <Col className="py-2" lg="6">
              <div className="cardCstm p-3 rounded bg-white">
                <div className="head m-0 mb-2">
                  <h4 className="m-0 fw-bold themeBlue">Earning Details</h4>
                </div>

                <Row className="border-bottom">
                  <Col md="4" sm="6" className="">
                    <div className="inner h-100 border-bottom pb-2">
                      <label
                        htmlFor=""
                        className="m-0 form-label themeBlue m-0"
                      >
                        Agency Earning
                      </label>
                      <p className="m-0 fw-bold themeClr">
                        ${data?.providerCommission}
                      </p>
                    </div>
                  </Col>
                  <Col md="4" sm="6" className="">
                    <div className="inner h-100 border-bottom pb-2">
                      <label
                        htmlFor=""
                        className="m-0 form-label themeBlue m-0"
                      >
                        Driver Earning
                      </label>
                      <p className="m-0 fw-bold themeClr">
                        ${data?.agencyDriverComission}
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col className="py-2" lg="6">
              <div className="cardCstm p-3 rounded bg-white">
                <div className="head m-0 mb-2">
                  <h4 className="m-0 fw-bold themeBlue">Vehicle</h4>
                </div>

                <Row className="border-bottom">
                  <Col md="4" sm="6" className="">
                    <div className="inner h-100 border-bottom pb-2">
                      <label
                        htmlFor=""
                        className="m-0 form-label themeBlue m-0"
                      >
                        Vehicle Type
                      </label>
                      <p className="m-0 fw-bold themeClr">
                        {data?.serviceType}
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

            <Row
              className="cardCstm rounded bg-white mt-4"
              style={{ marginLeft: "14px", width: "97.5%" }}
            >
              <Col lg="4" className="">
                <div className="inner h-100  pb-2 mt-2">
                  <h6 className="m-0 py-2 fw-bold themeBlue">Pickup Image:</h6>
                  {(Array.isArray(data?.serviceStartImage)
                    ? data?.serviceStartImage
                    : [data?.serviceStartImage]
                  )?.map((item, index) => (
                    <div key={index} className="mb-3">
                      <img
                        src={item || si1}
                        alt=""
                        width={100}
                        height={100}
                        onClick={() => handleImageClick(item || si1)}
                        style={{ cursor: "pointer" }}
                      />
                      <ImagePreview
                        showModal={showModalView}
                        selectedImage={selectedImage}
                        onClose={handleModalClose}
                      // title="Pickup Image Preview"
                      />
                    </div>
                  ))}
                </div>
              </Col>

              <Col lg="4" className="">
                <div className="inner h-100  pb-2 mt-2">
                  <h6 className="m-0 py-2 fw-bold themeBlue">Dropoff Image:</h6>
                  {(Array.isArray(data?.serviceEndImage)
                    ? data?.serviceEndImage
                    : [data?.serviceEndImage]
                  )?.map((item, index) => (
                    <div key={index} className="mb-3">
                      <img
                        src={item || si1}
                        alt=""
                        width={100}
                        height={100}
                        onClick={() => handleImageClick(item || si1)}
                        style={{ cursor: "pointer" }}
                      />
                      <ImagePreview
                        showModal={showModalView}
                        selectedImage={selectedImage}
                        onClose={handleModalClose}
                      // title="DropOff Image Preview"
                      />
                    </div>
                  ))}
                </div>
              </Col>
              <Col lg="4" className="">
                <div className="inner h-100  pb-2">
                  <h6 className="m-0 py-2 fw-bold themeBlue mt-2">
                    Document Image:
                  </h6>
                  <div className="d-flex flex-wrap gap-2">
                    {data?.driverDetails?.documentsList?.map((item, index) => (
                      // <div className="d-flex flex-row gap-10">
                      <div key={item._id} className="mb-3">
                        <img
                          // className="img-fluid w-100 rounded"
                          src={item?.image || si1}
                          alt=""
                          width={100}
                          height={100}
                          onClick={() => handleImageClick(item?.image || si1)}
                          style={{ cursor: "pointer" }}
                        />
                        <ImagePreview
                          showModal={showModalView}
                          selectedImage={selectedImage}
                          onClose={handleModalClose}
                        // title="Document Image Preview"
                        />
                      </div>
                      // </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg="12" className="">
                {data?.serviceType === "Towing" && (
                  <div className="py-2">
                    <div className="cardCstm p-3 rounded bg-white">
                      <div className="head m-0 mb-2">
                        <h4 className="m-0 fw-bold themeBlue">
                          Vehicle Details
                        </h4>
                      </div>
                      <Row className="">
                        <Col md="4" className="">
                          <div className="inner h-100 border-bottom pb-2">
                            <label
                              htmlFor=""
                              className="m-0 form-label themeBlue m-0"
                            >
                              Vehicle license plate number:
                            </label>
                            <p className="m-0 fw-bold themeClr">
                              {data?.towingVehicleDetails?.licensePlateNumber}
                            </p>
                          </div>
                        </Col>
                        <Col md="4" className="">
                          <div className="inner h-100 border-bottom pb-2">
                            <label
                              htmlFor=""
                              className="m-0 form-label themeBlue m-0"
                            >
                              Vehicle make:
                            </label>
                            <p className="m-0 fw-bold themeClr">
                              {data?.towingVehicleDetails?.make}
                            </p>
                          </div>
                        </Col>
                        <Col md="4" className="">
                          <div className="inner h-100 border-bottom pb-2">
                            <label
                              htmlFor=""
                              className="m-0 form-label themeBlue m-0"
                            >
                              Vehicle model:
                            </label>
                            <p className="m-0 fw-bold themeClr">
                              {data?.towingVehicleDetails?.model}
                            </p>
                          </div>
                        </Col>
                        <Col md="4" className="">
                          <div className="inner h-100 border-bottom pb-2">
                            <label
                              htmlFor=""
                              className="m-0 form-label themeBlue m-0"
                            >
                              Vehicle color:
                            </label>
                            <p className="m-0 fw-bold themeClr">
                              {data?.towingVehicleDetails?.color}
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <div className="py-2">
                        <h6 className="m-0 fw-bold themeBLue">
                          Vehicle images:
                        </h6>
                        <Row>
                          <Col sm="6" className="my-2">
                            <img
                              src={data?.towingVehicleDetails?.image}
                              alt=""
                              className="rounded"
                              width={100}
                              height={100}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
            <Col lg="4" className="my-2">
              <Row className="justify-content-start">
                <Col lg="2" className="col-6 my-2">
                  {/* {data?.status === "confirmed" && (
                    <Button
                      className="d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
                      type="button"
                      onClick={handleAssignDriver}
                    >
                      Assign
                    </Button>
                  )} */}
                </Col>
              </Row>
              <Modal
                show={showModal}
                onHide={handleClose}
                size="lg"
                style={{ marginLeft: "45px", marginTop: "45px" }}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Assign Driver List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <GetAssignDriver bookingId={id} />
                </Modal.Body>
              </Modal>
            </Col>

            {!!data?.status &&
              data?.status !== "confirmed" &&
              !data?.bidAmount && (
                <>
                  {
                    data?.bookingTypeRequest !== "normal" ?
                      <Col lg="4" className="col-6 my2">
                        <Button
                          className="d-flex align-items-center justify-content-center commonBtn w-100"
                          type="button"
                          onClick={handleOffer}
                        // disabled={!!data?.bidAmount}
                        >
                          Make Offer
                        </Button>
                      </Col>

                      :

                      <Col lg="4" className="col-6">
                        <Button
                          className="d-flex align-items-center justify-content-center commonBtn w-100 "
                          type="button"
                          onClick={(e) => acceptRejectHandler("accept")}
                        >
                          Accept
                        </Button>
                      </Col>
                  }
                  <Col lg="4" className="col-6">
                    <Button
                      className="d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
                      type="button"
                      onClick={(e) => acceptRejectHandler("reject")}
                    >
                      Reject
                    </Button>
                  </Col>

                </>)}

          </Row>
        </Container>
      </section>
    </>
  );
};

export default GuestBookingDetail;
